export const LEAD_EXECUTIVE_INDUSTRY_LIST = "LEAD_EXECUTIVE_INDUSTRY_LIST";
export const LEAD_EXECUTIVE_GEOLOCATION = "LEAD_EXECUTIVE_GEOLOCATION";
export const LEAD_EXECUTIVE_COMPANY_TYPE = "LEAD_EXECUTIVE_COMPANY_TYPE";
export const LEAD_EXECUTIVE_EMPLOYEE_COUNT = "LEAD_EXECUTIVE_EMPLOYEE_COUNT";
export const LEAD_EXECUTIVE_REVENUE_RANGE = "LEAD_EXECUTIVE_REVENUE_RANGE";
export const LEAD_EXECUTIVE_COMPANYLIST = "LEAD_EXECUTIVE_COMPANYLIST";
export const LEAD_EXECUTIVE_COMPANY_SEARCH_PAYLOAD =
  "LEAD_EXECUTIVE_COMPANY_SEARCH_PAYLOAD";
export const LEAD_EXECUTIVE_ADVANCED_SELECTED_FILTERS =
  "LEAD_EXECUTIVE_ADVANCED_SELECTED_FILTERS";
export const LEAD_EXECUTIVE_PAGINATION_VALUE =
  "LEAD_EXECUTIVE_PAGINATION_VALUE";
export const LEAD_EXECUTIVE_SELECTED_RECORDS =
  "LEAD_EXECUTIVE_SELECTED_RECORDS";
export const LEAD_EXECUTIVE_SAVE_SEARCH = "LEAD_EXECUTIVE_SAVE_SEARCH";
export const LEAD_EXECUTIVE_SAVE_SEARCH_LIST =
  "LEAD_EXECUTIVE_SAVE_SEARCH_LIST";
export const LEAD_EXECUTIVE_COMPANY_TAG_LIST =
  "LEAD_EXECUTIVE_COMPANY_TAG_LIST";
export const LEAD_EXECUTIVE_GROUP_COMPANY_TAG =
  "LEAD_EXECUTIVE_GROUP_COMPANY_TAG";
export const LEAD_EXECUTIVE_EMPLOYEELIST = "LEAD_EXECUTIVE_EMPLOYEELIST";
export const LEAD_STATUS_LIST = "LEAD_STATUS_LIST";
export const LEAD_PAGE_LAYOUT = "LEAD_PAGE_LAYOUT";

export const LEAD_EXECUTIVE_EMPTY_ERROR_OBJ_LISTING = "EMPTY_ERROR_OBJ_LISTING";
export const LEAD_EXECUTIVE_INDUSTRY_LIST_ERROR =
  "LEAD_EXECUTIVE_INDUSTRY_LIST_ERROR";

export const LEAD_EXECUTIVE_COMPANY_TYPE_ERROR =
  "LEAD_EXECUTIVE_COMPANY_TYPE_ERROR";
export const LEAD_EXECUTIVE_EMPLOYEE_COUNT_ERROR =
  "LEAD_EXECUTIVE_EMPLOYEE_COUNT_ERROR";
export const LEAD_EXECUTIVE_REVENUE_RANGE_ERROR =
  "LEAD_EXECUTIVE_REVENUE_RANGE_ERROR";
export const LEAD_EXECUTIVE_COMPANYLIST_ERROR =
  "LEAD_EXECUTIVE_COMPANYLIST_ERROR";
export const LEAD_EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR =
  "LEAD_EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR";
export const LEAD_EXECUTIVE_SAVE_SEARCH_ERROR =
  "LEAD_EXECUTIVE_SAVE_SEARCH_ERROR";
export const LEAD_EXECUTIVE_SAVE_SEARCH_LIST_ERROR =
  "LEAD_EXECUTIVE_SAVE_SEARCH_LIST_ERROR";
export const LEAD_EXECUTIVE_COMPANY_TAG_LIST_ERROR =
  "LEAD_EXECUTIVE_COMPANY_TAG_LIST_ERROR";
export const LEAD_EXECUTIVE_GROUP_COMPANY_TAG_ERROR =
  "LEAD_EXECUTIVE_GROUP_COMPANY_TAG_ERROR";
export const LEAD_EXECUTIVE_EMPLOYEELIST_ERROR =
  "LEAD_EXECUTIVE_EMPLOYEELIST_ERROR";
export const LEAD_STATUS_LIST_ERROR = "LEAD_STATUS_LIST_ERROR";

export const LEAD_RATING_LIST = "LEAD_RATING_LIST";
export const LEAD_RATING_LIST_ERROR = "LEAD_RATING_LIST_ERROR";

export const LEAD_EXECUTIVE_NOTES = "LEAD_EXECUTIVE_NOTES";
export const LEAD_EXECUTIVE_NOTES_ERROR = "LEAD_EXECUTIVE_NOTES_ERROR";

export const LEAD_EXECUTIVE_REMARKS = "LEAD_EXECUTIVE_REMARKS";
export const LEAD_EXECUTIVE_REMARKS_ERROR = "LEAD_EXECUTIVE_REMARKS_ERROR";

export const UNQUALIFIED_REASONS = "UNQUALIFIED_REASONS";
